import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router'
import Settings from './Settings';
import Auth from './Auth';
import Referee from './Referee';
import Messages from './Messages';
import Notifications from './Notifications';
import Item from './Item';

export default (history) => combineReducers({
  router: connectRouter(history),
  settings: Settings,
  auth: Auth,
  messages : Messages,
  referee: Referee,
  notifications: Notifications,
  item: Item
});
